import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import dataV from "@jiaminghi/data-view";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/reset.css";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import VirtualScroller from "vue-virtual-scroller";

createApp(App)
  .use(store)
  .use(router)
  .use(dataV)
  .use(VirtualScroller)
  .use(Antd)
  .mount("#app");
